module.exports = __webpack_public_path__ + "static/media/Node.0f83ae10.jpg";